import { createContext, useContext, type ReactNode } from 'react';
import {
  defaultSettingsFeatureFlags,
  type SettingsFeatureFlags,
} from '@/config/settingsFeatureFlags';

const SettingsFeatureFlagsContext = createContext<SettingsFeatureFlags | undefined>(undefined);

export function SettingsFeatureFlagsProvider({ children }: { children: ReactNode }) {
  return (
    <SettingsFeatureFlagsContext.Provider value={defaultSettingsFeatureFlags}>
      {children}
    </SettingsFeatureFlagsContext.Provider>
  );
}

export function useSettingsFeatureFlags(): SettingsFeatureFlags {
  const context = useContext(SettingsFeatureFlagsContext);
  if (context === undefined) {
    throw new Error('useSettingsFeatureFlags must be used within SettingsFeatureFlagsProvider');
  }
  return context;
}
